import { MarketValuationInterface } from '@interfaces/MarketValuation.interface';
import { MarketValuationStepperForm } from '../../components/page-components/market-valuation/MarketValuationStepper/types';
import BaseApiClient from '../BaseApiClient';
import { ListDataParams } from '../types';

export class APIMarketValuation extends BaseApiClient {
  /**
   * Get a market valuation results
   */
  async get(uuid: string): Promise<MarketValuationInterface[]> {
    return new Promise((resolve, reject) => {
      const params: ListDataParams = {
        filters: { uuid },
        page: 1,
        perPage: 10
      };
      this.client
        .getList('/market-valuation', params)
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get a market valuation results
   */
  async getFile(uuid: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/export-pdf/market-valuation/${uuid}`, {
          responseType: 'blob',
          headers: { Accept: 'application/pdf' }
        })
        .then((res) => {
          if (res.data) {
            resolve(
              URL.createObjectURL(
                new Blob([res.data], { type: 'application/pdf' })
              )
            );
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Create / recreate a market valuation results
   */
  async create(
    data: MarketValuationStepperForm
  ): Promise<MarketValuationInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/market-valuation', data)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { marketValuationQueryKeys } from './query-keys';
export {
  useMarketValuationQuery,
  useMarketValuationFileQuery
} from './use-market-valuation-queries';
export { useMarketValuationCreateMutation } from './use-market-valuation-mutations';
